import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
export function ActionPlanSection() {
  return <>
      <Section data-id="element-8">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#faf6f0] mb-8" data-id="element-9">
          What you'll do tonight (your first run)
        </h2>
        <div className="space-y-6 text-lg md:text-xl text-[#f5f0e8] leading-relaxed" data-id="element-10">
          <p data-id="element-11">You'll print (or screenshot) the Night Ladder. Then you'll run:</p>
          <ol className="list-decimal pl-6 space-y-3 text-[#d4cfc5] marker:text-[#c9a96e] marker:font-bold" data-id="element-12">
            <li data-id="element-13">Downshift</li>
            <li data-id="element-14">Depth checks (no guessing)</li>
            <li data-id="element-15">Feet → hips → torso → head</li>
            <li data-id="element-16">Hold-down 20–40 seconds</li>
            <li data-id="element-17">Fade-out slowly</li>
            <li data-id="element-18">90-second watch</li>
            <li data-id="element-19">
              If it fails: identify the failure type and change one variable,
              not ten.
            </li>
          </ol>
          <p className="mt-6" data-id="element-20">
            And if you're at risk of falling asleep holding baby: you'll use the{' '}
            <span className="text-[#c9a96e] font-bold" data-id="element-21">Safety Reset rung</span>{' '}
            instead of pushing through and hoping.
          </p>
        </div>
      </Section>

      <Section className="text-center" id="pricing" data-id="element-22">
        <div className="mb-16" data-id="element-23">
          <div className="inline-block bg-[#c9a96e] text-[#0f0f23] font-bold text-xs uppercase tracking-wider px-3 py-1 rounded-full mb-4 animate-pulse" data-id="element-24">
            Launch Price — Won't Last
          </div>
          <p className="text-[#d4cfc5] text-lg mb-2" data-id="element-25">
            <span className="line-through opacity-60" data-id="element-26">$19.00</span>
          </p>
          <h2 className="text-5xl md:text-6xl font-serif font-bold text-[#c9a96e] mb-3" data-id="element-27">
            $6.36
          </h2>
          <p className="inline-block bg-[#8fae8b]/15 text-[#8fae8b] font-bold text-sm px-3 py-1 rounded-full mb-3" data-id="element-28">
            You save $12.64 (67% off)
          </p>
          <p className="text-[#d4cfc5] text-lg" data-id="element-29">Instant digital access.</p>
        </div>

        <div className="bg-[#1a1a2e] p-8 rounded-lg border border-[#b8a9c9]/30 mb-8 text-left" data-id="element-30">
          <h3 className="text-xl font-serif font-bold text-[#faf6f0] mb-4" data-id="element-31">
            3-Night Promise
          </h3>
          <p className="text-[#f5f0e8] text-lg leading-relaxed" data-id="element-32">
            Run the protocol for 3 nights. If you don't see any progress toward
            safer bassinet sleep, email us and we'll refund every cent. No
            questions.
          </p>
        </div>

        <p className="text-[#d4cfc5] text-base italic mb-16 max-w-2xl mx-auto" data-id="element-33">
          Built by a mother who lived the 2am loop — and a pediatric sleep
          consultant who helped her break it.
        </p>

        <div className="space-y-8 mb-12" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#faf6f0]" data-id="element-35">
            You don't need more tips.
          </h2>
          <p className="text-xl text-[#f5f0e8] leading-relaxed" data-id="element-36">
            You need something that tells you what to do when:
          </p>
          <ul className="text-left max-w-md mx-auto space-y-3 text-lg text-[#d4cfc5]" data-id="element-37">
            <li className="flex items-center" data-id="element-38">
              <span className="w-2 h-2 bg-[#b8a9c9] rounded-full mr-4" data-id="element-39"></span>
              It's dark,
            </li>
            <li className="flex items-center" data-id="element-40">
              <span className="w-2 h-2 bg-[#b8a9c9] rounded-full mr-4" data-id="element-41"></span>
              Your baby is finally calm,
            </li>
            <li className="flex items-center" data-id="element-42">
              <span className="w-2 h-2 bg-[#b8a9c9] rounded-full mr-4" data-id="element-43"></span>
              Your arms are shaking,
            </li>
            <li className="flex items-center" data-id="element-44">
              <span className="w-2 h-2 bg-[#b8a9c9] rounded-full mr-4" data-id="element-45"></span>
              And you're thinking, "If this transfer fails again, I don't know
              what I'll do."
            </li>
          </ul>
          <p className="text-xl font-medium text-[#faf6f0] pt-4" data-id="element-46">
            That moment is exactly what this was built for.
          </p>
        </div>

        <CTAButton className="w-full md:w-auto text-xl px-10 py-5" directCheckout data-id="element-47">
          Get the Emergency Night Protocol — $6.36
        </CTAButton>

        <p className="mt-8 text-sm text-[#d4cfc5] opacity-60" data-id="element-48">
          Secure payment via Stripe. Instant PDF download.
        </p>
      </Section>
    </>;
}